import React, { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomePage from "./features/Home/HomePage";
import CarDetail from "./features/CarDetails/CarDetail";
import { useDispatch, useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import { messages } from "./utils/Lang/Messages";
import { LOCALES } from "./utils/Lang/Locales";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  detectMedia,
  refetchToken,
  setApiErrorStatus,
  setAuthToken,
  setLoggeInUser,
  showLoader,
} from "./utils/globalSlice";
import { useGetTokenQuery } from "./app/api/Apis";
import { jwtDecode } from "jwt-decode";
import SecureLS from "secure-ls";
import MainLoader from "./components/Loaders/MainLoader";
import { register } from "swiper/element";
import ErrorBoundary from "./components/ErrorBoundary";
import "../src/global.css";

function App() {
  const theme = useTheme(); // useTheme hook defenition to use mui theme
  const matches = useMediaQuery(theme.breakpoints.down("sm")); // useMediaQuery hook defined to check viewport

  register(); // register swiper elements

  const dispatch = useDispatch(); // define useDispatch hook of redux to dispatch actions

  const loading = useSelector((state) => state.global.loader); // get loader state from global redux store
  const lang = useSelector((state) => state.global.language); // get language from global redux store
  const refetchTokenState = useSelector((state) => state.global.tokenRefetch); // get token refetch status

  const ls = new SecureLS({ encodingType: "aes" }); // define secure ls
  const ssoToken = ls.get("ssoToken"); // get ssotoken from localStorage

  // dispatch action detectMedia to set the viewport on app load
  useEffect(() => {
    dispatch(detectMedia(matches));
  }, [matches]);

  //  check if ssotoken available, decode and set in redux state using setLoggeInUser hook
  useEffect(() => {
    if (ssoToken) {
      const user = jwtDecode(ssoToken);
      dispatch(setLoggeInUser(user));
    }
  }, [ssoToken]);

  // create routers
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/:slug",
      element: <CarDetail />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: "*",
      element: <ErrorBoundary />,
    },
  ]);

  // use query hook to generate token to use in api calls
  // const { isError, isLoading, error, data, refetch } = useGetTokenQuery();

  // set loader, to show loading animtion as per token query loading state
  // useEffect(() => {
  //   if (isLoading) {
  //     dispatch(showLoader(true));

  //     return () => {
  //       dispatch(showLoader(false));
  //     };
  //   }
  // }, [isLoading]);

  //useeffect hook to handle refetch token if token fails based on state, data & error values of token query
  // useEffect(() => {
  //   if (refetchTokenState) {
  //     refetch();
  //     return () => {
  //       if (data || isError) {
  //         dispatch(refetchToken(0));
  //       }
  //     };
  //   }
  // }, [refetchTokenState, data, isError]);

  // set error to show error component as per token query error state
  // useEffect(() => {
  //   if (isError) {
  //     dispatch(setApiErrorStatus(error.status));
  //     return () => {
  //       // dispatch(setApiErrorStatus(""));
  //     };
  //   }
  // }, [isError]);

  return (
    <div dir={lang === "en" ? "ltr" : "rtl"}>
      <IntlProvider
        fallbackOnEmptyString={false}
        messages={messages[lang]}
        locale={lang}
        defaultLocale={LOCALES.ARABIC}
      >
        <RouterProvider router={router} />
      </IntlProvider>
      <MainLoader open={loading} />
    </div>
  );
}

export default App;
